import { FC, ReactNode } from 'react';
import { Modal as AntdModal } from 'antd';

import styles from './styles.module.css';

const DEFAULT_MODAL_WIDTH = 600;

interface Props {
    title: ReactNode;
    footer: ReactNode;
    onClose: () => void;
    children: ReactNode;
    maskClosable?: boolean;
    closable?: boolean;
    width?: number;
}

export const Modal: FC<Props> = ({
    title,
    footer,
    onClose,
    children,
    maskClosable = true,
    closable = true,
    width = DEFAULT_MODAL_WIDTH,
}) => (
    <AntdModal
        open
        centered
        title={title}
        onCancel={onClose}
        footer={footer}
        maskClosable={maskClosable}
        closable={closable}
        rootClassName={styles.modal}
        width={width}
    >
        {children}
    </AntdModal>
);
